export default "__VITE_ASSET__DUm1zJFR__"